import { Box, Flex } from "@mantine/core";
import { ReactElement } from "react";
import { SLIDER_THUMB_INNER_SIZE, SLIDER_THUMB_SIZE } from "./constants";
import { useStyles } from "./StorageSlider.styled";

export function StorageSliderThumb(): ReactElement {
  const { classes } = useStyles();

  return (
    <Flex
      data-testid="StorageSlider-thumb"
      align="center"
      direction="row"
      justify="center"
      h={SLIDER_THUMB_SIZE}
      ta="center"
      w={SLIDER_THUMB_SIZE}
    >
      <Box
        className={classes.thumbInnerDot}
        bg="brand.4"
        h={SLIDER_THUMB_INNER_SIZE}
        w={SLIDER_THUMB_INNER_SIZE}
      />
    </Flex>
  );
}
